import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoujjaincab() {



  const cardData =
  {
    keyword: 'Mumbai to Ujjain Cab',
    heading: 'Shambhu Cabs: Mumbai to Ujjain Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Ujjain Cab services, providing safe, comfortable, and hassle-free long-distance travel for families, pilgrims, corporate travelers, and groups visiting the sacred city of Ujjain. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Ujjain with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes your pilgrimage, business, or leisure trip convenient, stress-free, and memorable. For comfort, safety, and a trusted Mumbai to Ujjain cab experience, Shambhu Cabs is your reliable travel partner.',

    top: 'Top Places to Visit in Ujjain with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga",
    "description": "Mahakaleshwar Temple is one of the 12 Jyotirlingas and Ujjain’s most sacred Hindu pilgrimage site. Dedicated to Lord Shiva, the temple is famous for its Bhasma Aarti performed at dawn. Its ancient stone architecture, massive spire, and richly decorated sanctum attract devotees from all over India. Festivals like Maha Shivaratri see grand celebrations, making it a spiritual and cultural hub."
  },
  {
    "title": "Kal Bhairav Temple",
    "description": "Kal Bhairav Temple is dedicated to Lord Bhairav, a fierce manifestation of Shiva. The temple is renowned for its unique offerings of liquor by devotees. It is a significant religious site, known for its historic stone carvings, peaceful ambiance, and intense spiritual energy, attracting pilgrims seeking protection and blessings."
  },
  {
    "title": "Harsiddhi Temple",
    "description": "Harsiddhi Temple is dedicated to Goddess Harsiddhi, a powerful form of Shakti. The temple features two towering statues of the goddess, beautiful carvings, and a traditional temple courtyard. It is a prominent spiritual center in Ujjain, known for its vibrant festivals and religious rituals."
  },
  {
    "title": "Ram Ghat",
    "description": "Ram Ghat, located on the banks of the Shipra River, is a historic ghat famous for ritualistic bathing during Kumbh Mela and daily aarti ceremonies. Pilgrims and tourists enjoy serene river views, the spiritual ambiance, and observing traditional Hindu rituals. It is an essential part of Ujjain’s religious life."
  },
  {
    "title": "Chintaman Ganesh Temple",
    "description": "Chintaman Ganesh Temple, dedicated to Lord Ganesha, is one of the oldest and largest temples in Ujjain. Devotees come here to offer prayers and seek relief from worries. The temple complex features intricate carvings, spacious halls, and a calm spiritual environment."
  },
  {
    "title": "Bade Ganeshji Ka Mandir",
    "description": "Bade Ganeshji Ka Mandir is a famous temple housing a massive idol of Lord Ganesha. Its large prayer hall, traditional architecture, and daily rituals make it a popular spiritual destination for locals and tourists alike."
  },
  {
    "title": "Vedh Shala (Observatory)",
    "description": "Vedh Shala, established by Maharaja Jai Singh II, is an ancient astronomical observatory. It features large instruments for studying celestial movements, reflecting India’s rich scientific heritage. Visitors can explore historical tools, learn about astronomy, and enjoy the architectural grandeur."
  },
  {
    "title": "ISKCON Ujjain",
    "description": "ISKCON Temple in Ujjain is a center for devotion, meditation, and cultural learning. It features colorful architecture, a serene environment, regular spiritual programs, and beautiful idol worship. The temple attracts devotees and tourists interested in Vaishnavism and peaceful meditation."
  },
  {
    "title": "Kaliadeh Palace",
    "description": "Kaliadeh Palace, situated on the banks of the Shipra River, is a historic structure known for its elegant architecture, stone carvings, and scenic riverside views. It served as a royal residence and now attracts tourists for photography, heritage walks, and peaceful surroundings."
  },
  {
    "title": "Gopal Mandir",
    "description": "Gopal Mandir is dedicated to Lord Krishna and features beautiful stone carvings, traditional architecture, and daily rituals. The temple is a lively spiritual center, especially during festivals like Janmashtami, offering devotees and tourists a blend of devotion, history, and cultural experience."
  }
],




"services": [
  {
    "name": "Mumbai Ujjain Taxi",
    "description": "Mumbai Ujjain Taxi provides reliable travel from Mumbai to Ujjain with professional drivers and comfortable vehicles for all travelers."
  },
  {
    "name": "Mahakaleshwar Cab Mumbai",
    "description": "Mahakaleshwar Cab Mumbai offers dedicated pilgrimage transport for visiting the Mahakaleshwar temple, ensuring a safe and comfortable journey."
  },
  {
    "name": "One Way Cab Mumbai Ujjain",
    "description": "One Way Cab Mumbai Ujjain is ideal for travelers seeking a single-direction trip, with affordable fares and timely service."
  },
  {
    "name": "Affordable Mumbai Ujjain Cab",
    "description": "Affordable Mumbai Ujjain Cab ensures cost-effective travel without compromising comfort or safety for pilgrims and tourists."
  },
  {
    "name": "Intercity Cab Mumbai to Ujjain",
    "description": "Intercity Cab Mumbai to Ujjain provides smooth long-distance travel, perfect for both leisure and business trips."
  },
  {
    "name": "SUV Cab Mumbai Ujjain",
    "description": "SUV Cab Mumbai Ujjain offers spacious rides for families or groups traveling to Ujjain, ensuring comfort during the journey."
  },
  {
    "name": "Sedan Taxi Mumbai Ujjain",
    "description": "Sedan Taxi Mumbai Ujjain is a comfortable and economical option for solo travelers or small families visiting Ujjain."
  },
  {
    "name": "Long Distance Cab Mumbai Ujjain",
    "description": "Long Distance Cab Mumbai Ujjain provides efficient and safe travel options for extended trips from Mumbai to Ujjain."
  },
  {
    "name": "24x7 Cab Mumbai Ujjain",
    "description": "24x7 Cab Mumbai Ujjain ensures round-the-clock taxi availability for early departures or late-night arrivals."
  },
  {
    "name": "Premium Cab Mumbai Ujjain",
    "description": "Premium Cab Mumbai Ujjain offers luxury sedans and SUVs for travelers looking for comfort and style on the Mumbai-Ujjain route."
  },
  {
    "name": "Safe Taxi Mumbai Ujjain",
    "description": "Safe Taxi Mumbai Ujjain focuses on passenger safety with well-maintained vehicles and experienced drivers."
  },
  {
    "name": "Pilgrimage Cab Mumbai Ujjain",
    "description": "Pilgrimage Cab Mumbai Ujjain specializes in temple visits, offering convenient travel for groups and families visiting Mahakaleshwar."
  },
  {
    "name": "Fast Taxi Mumbai Ujjain",
    "description": "Fast Taxi Mumbai Ujjain optimizes routes to ensure quick and efficient travel from Mumbai to Ujjain."
  },
  {
    "name": "Business Trip Cab Mumbai Ujjain",
    "description": "Business Trip Cab Mumbai Ujjain caters to corporate travelers needing punctual and professional taxi services."
  },
  {
    "name": "Round Trip Mumbai Ujjain Cab",
    "description": "Round Trip Mumbai Ujjain Cab is perfect for travelers looking for convenient return journey options with comfort and reliability."
  }
],

"tableData": [
  ["Mumbai Ujjain Taxi", "Mahakaleshwar Cab Mumbai"],
  ["One Way Cab Mumbai Ujjain", "Affordable Mumbai Ujjain Cab"],
  ["Intercity Cab Mumbai to Ujjain", "SUV Cab Mumbai Ujjain"],
  ["Sedan Taxi Mumbai Ujjain", "Long Distance Cab Mumbai Ujjain"],
  ["24x7 Cab Mumbai Ujjain", "Premium Cab Mumbai Ujjain"],
  ["Safe Taxi Mumbai Ujjain", "Pilgrimage Cab Mumbai Ujjain"],
  ["Fast Taxi Mumbai Ujjain", "Business Trip Cab Mumbai Ujjain"],
  ["Round Trip Mumbai Ujjain Cab", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Ujjain Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Ujjain cab services, perfect for pilgrimage trips, family travel, and comfortable long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to enjoy a smooth and comfortable ride from Mumbai to Ujjain."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with Mumbai to Ujjain routes, ensuring safe driving, timely arrivals, and a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We offer clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included for your Mumbai to Ujjain cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route guidance, and any travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans tailored to your Mumbai to Ujjain journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Ujjain journey smooth, comfortable, and worry-free."
  }
]

































  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Ujjain?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Ujjain, ensuring a peaceful and safe journey to the famous Mahakaleshwar Jyotirlinga and other attractions.',
  },
  {
    question: 'How can I book a cab from Mumbai to Ujjain?',
    answer: 'You can easily book a cab from Mumbai to Ujjain through our website, mobile app, or by contacting our 24x7 customer support team for a seamless and convenient booking experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Ujjain cab bookings?',
    answer: 'Shambhu Cabs offers a variety of vehicles for your journey from Mumbai to Ujjain, including sedans, SUVs, luxury cars, and Tempo Travellers for larger groups or family trips.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Ujjain journey?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the route from Mumbai to Ujjain, ensuring a smooth, comfortable, and safe journey.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Ujjain trip?',
    answer: 'Yes, you can select your preferred pickup and drop-off locations in Mumbai and Ujjain, providing you with maximum flexibility and convenience for your journey.',
  },
  {
    question: 'Is the Mumbai to Ujjain cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs provides 24x7 service for your journey from Mumbai to Ujjain, allowing you to travel at any time that fits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Ujjain trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene measures to ensure your safety and well-being during the trip.',
  },
  {
    question: 'What payment options are available for Mumbai to Ujjain cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all Mumbai to Ujjain cab bookings.',
  },
  {
    question: 'Is customer support available during my Mumbai to Ujjain trip?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support to assist you throughout your journey from Mumbai to Ujjain.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Shankar Jain',
    feedback: 'Our trip from Mumbai to Ujjain was incredibly smooth and comfortable thanks to Shambhu Cabs. The driver was professional, and the car was in great condition.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sunita Verma',
    feedback: 'I had a wonderful experience traveling from Mumbai to Ujjain with Shambhu Cabs. The service was exceptional, and the driver made sure we were comfortable throughout the journey.',
    rating: 5,
  },
];
















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const mumbaiUjjainCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Ujjain Cab",
  "serviceType": "Outstation / Pilgrimage Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-ujjain-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Ujjain cab services. Book affordable, SUV, sedan, and premium cabs for one-way, round trip, pilgrimage, or business travel, available 24×7.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-ujjain-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Ujjain, India" }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Ujjain Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Ujjain cab services with Shambhu Cabs. Affordable SUV, sedan, and premium cabs for one-way, round trip, pilgrimage, or business travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Ujjain Taxi, Mahakaleshwar Cab Mumbai, One Way Cab Mumbai Ujjain, Affordable Mumbai Ujjain Cab, Intercity Cab Mumbai to Ujjain, SUV Cab Mumbai Ujjain, Sedan Taxi Mumbai Ujjain, Long Distance Cab Mumbai Ujjain, 24x7 Cab Mumbai Ujjain, Premium Cab Mumbai Ujjain, Safe Taxi Mumbai Ujjain, Pilgrimage Cab Mumbai Ujjain, Fast Taxi Mumbai Ujjain, Business Trip Cab Mumbai Ujjain, Round Trip Mumbai Ujjain Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(mumbaiUjjainCabSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoujjaincab;